import instance from '../axios.config';

export const enrollMFA = async () => {
  const { data } = await instance.post('/mfa/enroll');
  return data;
};

export const verifyMFA = async (token) => {
  const { data } = await instance.post('/mfa/verify', { token });
  return data;
};

export const getMFAStatus = async () => {
  const { data } = await instance.get('/mfa/status');
  return data;
};

export const generateBackupCodes = async () => {
  const { data } = await instance.post('/mfa/backup-codes');
  return data;
};

export const disableMFA = async (password) => {
  const { data } = await instance.post('/mfa/disable', { password });
  return data;
};
